export default "__VITE_ASSET__BFnDorqJ__"